import React from 'react';
import Title from '../title/Title';

const InfoItem = ({ infoTitle, infoValue }) => (
    <li className="mb-2">
        <div className="row">
            <div className="col-4 font-weight-bold">{infoTitle}</div>
            <div className="col-8">{infoValue}</div>
        </div>
    </li>
);

class InfoList extends React.Component{

    state = {
        allInfo: [
            {
                infoTitle: 'Age',
                infoValue: 17,
            },
            {
                infoTitle: 'Languages',
                infoValue: 'English, Indonesia, Japanese',
            },
            {
                infoTitle: 'Nationality',
                infoValue: 'Indonesian',
            },
            {
                infoTitle: 'Address',
                infoValue: 'Tegal Jawa tengah, Indonesia',
            },
            {
                infoTitle: 'Kurobotz started',
                infoValue: '8 February 2023',
            },
        ]
    }

    render(){
        return(
            <>
                <Title>TENTANG GUA CUY</Title>
                <ul className="list-unstyled p-3">
                    {
                        this.state.allInfo.map((item, index) => (
                            <InfoItem key={index} {...item} />
                        ))
                    }
                </ul>
            </>
        );
    }
}

export default InfoList;